import type { App } from 'vue'
import { createI18n } from 'vue-i18n'
import type { I18n, I18nOptions } from 'vue-i18n'
import zhCN from '@/locales/zh-CN'

export let i18n: ReturnType<typeof createI18n>

const setHtmlPageLang = (locale: string) => {
  document.querySelector('html')?.setAttribute('lang', locale)
}

const createI18nOptions = (): I18nOptions => {
  const lang = 'zh-CN'
  setHtmlPageLang(lang)
  return {
    legacy: false,
    locale: lang,
    fallbackLocale: lang,
    messages: {
      [lang]: zhCN
    },
    availableLocales: [lang],
    sync: true,
    silentTranslationWarn: true,
    missingWarn: false,
    silentFallbackWarn: true
  }
}

export const setupI18n = async (app: App<Element>) => {
  const options = createI18nOptions()
  i18n = createI18n(options) as I18n
  app.use(i18n)
}
